import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './industry.reducer';

export const IndustryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const industryEntity = useAppSelector(state => state.industry.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="industryDetailsHeading">
          <Translate contentKey="apiLocationApp.industry.detail.title">Industry</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{industryEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.industry.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{industryEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.industry.date">Date</Translate>
            </span>
          </dt>
          <dd>{industryEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.industry.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{industryEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.industry.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{industryEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.industry.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{industryEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="agricultureForestryFishing">
              <Translate contentKey="apiLocationApp.industry.agricultureForestryFishing">Agriculture Forestry Fishing</Translate>
            </span>
          </dt>
          <dd>{industryEntity.agricultureForestryFishing}</dd>
          <dt>
            <span id="miningQuarrying">
              <Translate contentKey="apiLocationApp.industry.miningQuarrying">Mining Quarrying</Translate>
            </span>
          </dt>
          <dd>{industryEntity.miningQuarrying}</dd>
          <dt>
            <span id="manufacturing">
              <Translate contentKey="apiLocationApp.industry.manufacturing">Manufacturing</Translate>
            </span>
          </dt>
          <dd>{industryEntity.manufacturing}</dd>
          <dt>
            <span id="electricityGasWater">
              <Translate contentKey="apiLocationApp.industry.electricityGasWater">Electricity Gas Water</Translate>
            </span>
          </dt>
          <dd>{industryEntity.electricityGasWater}</dd>
          <dt>
            <span id="construction">
              <Translate contentKey="apiLocationApp.industry.construction">Construction</Translate>
            </span>
          </dt>
          <dd>{industryEntity.construction}</dd>
          <dt>
            <span id="wholesaleRetailTrade">
              <Translate contentKey="apiLocationApp.industry.wholesaleRetailTrade">Wholesale Retail Trade</Translate>
            </span>
          </dt>
          <dd>{industryEntity.wholesaleRetailTrade}</dd>
          <dt>
            <span id="transportationStorage">
              <Translate contentKey="apiLocationApp.industry.transportationStorage">Transportation Storage</Translate>
            </span>
          </dt>
          <dd>{industryEntity.transportationStorage}</dd>
          <dt>
            <span id="accommodationFoodService">
              <Translate contentKey="apiLocationApp.industry.accommodationFoodService">Accommodation Food Service</Translate>
            </span>
          </dt>
          <dd>{industryEntity.accommodationFoodService}</dd>
          <dt>
            <span id="informationCommunication">
              <Translate contentKey="apiLocationApp.industry.informationCommunication">Information Communication</Translate>
            </span>
          </dt>
          <dd>{industryEntity.informationCommunication}</dd>
          <dt>
            <span id="financialInsurance">
              <Translate contentKey="apiLocationApp.industry.financialInsurance">Financial Insurance</Translate>
            </span>
          </dt>
          <dd>{industryEntity.financialInsurance}</dd>
          <dt>
            <span id="realEstate">
              <Translate contentKey="apiLocationApp.industry.realEstate">Real Estate</Translate>
            </span>
          </dt>
          <dd>{industryEntity.realEstate}</dd>
          <dt>
            <span id="professionalScientific">
              <Translate contentKey="apiLocationApp.industry.professionalScientific">Professional Scientific</Translate>
            </span>
          </dt>
          <dd>{industryEntity.professionalScientific}</dd>
          <dt>
            <span id="administrativeSupport">
              <Translate contentKey="apiLocationApp.industry.administrativeSupport">Administrative Support</Translate>
            </span>
          </dt>
          <dd>{industryEntity.administrativeSupport}</dd>
          <dt>
            <span id="publicAdministration">
              <Translate contentKey="apiLocationApp.industry.publicAdministration">Public Administration</Translate>
            </span>
          </dt>
          <dd>{industryEntity.publicAdministration}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="apiLocationApp.industry.education">Education</Translate>
            </span>
          </dt>
          <dd>{industryEntity.education}</dd>
          <dt>
            <span id="humanHealthSocialWork">
              <Translate contentKey="apiLocationApp.industry.humanHealthSocialWork">Human Health Social Work</Translate>
            </span>
          </dt>
          <dd>{industryEntity.humanHealthSocialWork}</dd>
          <dt>
            <span id="artsEntertainment">
              <Translate contentKey="apiLocationApp.industry.artsEntertainment">Arts Entertainment</Translate>
            </span>
          </dt>
          <dd>{industryEntity.artsEntertainment}</dd>
          <dt>
            <span id="otherServiceActivities">
              <Translate contentKey="apiLocationApp.industry.otherServiceActivities">Other Service Activities</Translate>
            </span>
          </dt>
          <dd>{industryEntity.otherServiceActivities}</dd>
          <dt>
            <span id="householdEmployers">
              <Translate contentKey="apiLocationApp.industry.householdEmployers">Household Employers</Translate>
            </span>
          </dt>
          <dd>{industryEntity.householdEmployers}</dd>
        </dl>
        <Button tag={Link} to="/industry" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/industry/${industryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IndustryDetail;
